import { createFileRoute, useParams } from "@tanstack/react-router";
import { createRecordAttachmentsListQueryOptions } from "@/features/attachments/adapters/record-attachments-adapter";
import { RecordAttachmentsWorkspace } from "@/features/attachments/components/record-attachments-workspace";
import { ATTACHMENTS_FILES_PAGE_SIZE } from "@/features/attachments/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/attachments",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createRecordAttachmentsListQueryOptions({
				recordId: params.recordId,
				organizationId: params.orgId,
				start: 1,
				count: ATTACHMENTS_FILES_PAGE_SIZE,
			}),
		),
	component: NestedRecordWorkspaceAttachmentsTab,
});

/**
 * Nested record workspace Attachments tab under an asset — thin route adapter.
 */
function NestedRecordWorkspaceAttachmentsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/attachments",
	});

	return (
		<RecordAttachmentsWorkspace
			orgId={params.orgId}
			recordId={params.recordId}
		/>
	);
}
